import {
  Button,
  TextInputField,
  Tooltip,
  IconEyeOpen,
  IconEyeSlash
} from '@sequencehq/core-components'
import { useState } from 'react'

type Props = {
  label: string
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  validationErrors?: { message: string }[]
  disabled?: boolean
  'data-testid': string
}

// TODO: refactor this into a core-component
export const MaskedTextInputField = ({
  label,
  value,
  onChange,
  validationErrors,
  disabled,
  'data-testid': dataTestid
}: Props) => {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <TextInputField
      label={label}
      data-testid={dataTestid}
      value={value}
      onChange={onChange}
      validationErrors={validationErrors}
      type={isVisible ? 'text' : 'password'}
      fullWidth
      autoComplete="off"
      disabled={disabled}
      suffix={
        <Tooltip
          label={isVisible ? `Hide ${label}` : `Show ${label}`}
          placement="top"
          shouldWrapChildren={false}
        >
          <Button
            data-testid={`${dataTestid}.toggle`}
            aria-label={isVisible ? `Hide ${label}` : `Show ${label}`}
            icon={isVisible ? <IconEyeSlash /> : <IconEyeOpen />}
            variant="unstyled"
            size="16px"
            onClick={() => setIsVisible(prev => !prev)}
          />
        </Tooltip>
      }
      suffixStyles={{ pointerEvents: 'auto' }}
    />
  )
}
